import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { getQuestions } from '../utils';

const PreviewComputerSkills = ({ previews}) => {
  const questions = getQuestions(previews, 'computer-skills');
  const cs1 = questions['CS1'];
  const answers = [];
  if(questions['CS1'] !== undefined) {
    questions['CS1']['answer'].forEach((ans) => {
      answers.push(ans);
    });
  }
  answers.push(null);
  const answersLength = answers.length;
  let answerIndex =1;
  return (
      <Box  className='computerSkills contentBox'>
        {typeof cs1 !== 'undefined' && typeof cs1['answer'] !== 'undefined' && cs1['answer'].length > 0 &&
          <Box className='csContentBox'>
            <Text className='techSkills'>Technical Skills: </Text>
            {Object.values(answers).map((answer) => {
              answerIndex++;
              const comma = answerIndex < answersLength ? ',' :'.';
              return (
                <Text className='comma'>{answer}{comma}</Text>
              )
            })}
          </Box>
        }
      </Box>
)
  ;
};
export default PreviewComputerSkills;
